<template>
  <v-container fluid>
    <page-header title="Cron de códigos de ETL" subtitle="Ejecución de scripts de ETL" />
    <v-row class="mt-4" justify="center">
      <v-col cols="12" md="8">
        <v-card class="pa-4">
          <v-card-title class="justify-center">Encuestas CI</v-card-title>
          
          <v-card-text>
            <v-text-field
              :value="fileEncuestas ? fileEncuestas.name : ''"
              label="Código"
              readonly
              dense
              hide-details
              append-outer-icon="mdi-download"
              @click:append-outer="downloadFile(fileEncuestas)"
            />

            <v-btn
              class="mt-3 white--text"
              color="primary"
              block
              :loading="loadingEncuestas"
              @click="activar(jobIdEncuestas)"
            >
              ACTIVAR
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card class="pa-4">
          <v-card-title class="justify-center">Panel CI</v-card-title>
          
          <v-card-text>
            <v-text-field
              :value="filePanel ? filePanel.name : ''"
              label="Código"
              readonly
              dense
              hide-details
              append-outer-icon="mdi-download"
              @click:append-outer="downloadFile(filePanel)"
            />

            <v-btn
              class="mt-3 white--text"
              color="primary"
              block
              :loading="loadingPanel"
              @click="activar(jobIdPanel)"
            >
              ACTIVAR
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeader from '@/components/page-header.vue'
import Swal from 'sweetalert2'



export default {
  name: 'CronView',
  components: { PageHeader },
  data() {
    return {
      jobIdEncuestas: '8',
      jobIdPanel: '9',
      fileEncuestas: null,
      filePanel: null,
      loadingEncuestas: false,
      loadingPanel: false,
    };
  },
  mounted() {
    this.initFiles();
  },
  methods: {
    async initFiles() {
      
      this.fileEncuestas = await this.getArchives(this.jobIdEncuestas, 'EncuestasCI.zip');
      this.filePanel = await this.getArchives(this.jobIdPanel, 'PanelCI.zip');
    },

    async getArchives(id, defaultFilename) {
      const cronBase = (process.env.VUE_APP_URL_CRON || process.env.VUE_URL_CRON || 'https://devcronjobs.copecflux.cl').replace(/\/$/, '')
      const cronKey = process.env.VUE_APP_KEY_CRON || process.env.VUE_KEY_CRON || ''
      const url = `${cronBase}/get/archives?id=${encodeURIComponent(id)}`

      try {
        const headers = {}
        if (cronKey) headers['Authorization'] = `Bearer ${cronKey}`

        const res = await fetch(url, { method: 'GET', headers })
        
        console.log(`[getArchives] Response for ${id}:`, res.status);

        if (!res.ok) {
          console.error(`Error fetching archive ${id}:`, res.status)
          return null
        }

        let filename = defaultFilename;
        const disposition = res.headers.get('content-disposition');
        

        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) { 
            filename = matches[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            } catch (e) {
                console.warn('Error decoding filename', e);
            }
          }
        }

        const blob = await res.blob()
        console.log(`[getArchives] Blob received for ${id}, size:`, blob.size, 'type:', blob.type);
        
        const type = blob.type === 'application/octet-stream' || !blob.type ? 'application/zip' : blob.type;
        return new File([blob], filename, { type: type })

      } catch (err) {
        console.error(`Error fetching archive ${id}:`, err)
        return null
      }
    },

    async activar(id) {
      if (id === this.jobIdEncuestas) this.loadingEncuestas = true;
      if (id === this.jobIdPanel) this.loadingPanel = true;

      const cronBase = (process.env.VUE_APP_URL_CRON || process.env.VUE_URL_CRON || 'https://devcronjobs.copecflux.cl').replace(/\/$/, '')
      const cronKey = process.env.VUE_APP_KEY_CRON || process.env.VUE_KEY_CRON || ''
      const url = `${cronBase}/manualrun/job?id=${encodeURIComponent(id)}`

      try {
        const headers = {}
        if (cronKey) headers['Authorization'] = `Bearer ${cronKey}`

        const res = await fetch(url, { method: 'GET', headers })
        const text = await res.text()
        if (!res.ok) {
          console.error('Cron response error:', res.status, text)
          throw new Error(text || `Status ${res.status}`)
        }

        // console.log('Cron response:', text)
        Swal.fire({
          icon: 'success',
          title: 'Job ejecutado correctamente',
          confirmButtonText: 'OK',
          customClass: { confirmButton: 'white--text' }, 
          text: text || 'éxito.'
        })
      } catch (err) {
        // console.error(err)
        const message = err && err.message ? err.message : 'Error al ejecutar job cron'
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message,
          confirmButtonText: 'OK',
          customClass: { confirmButton: 'white--text' },
        })
      } finally {
        if (id === this.jobIdEncuestas) this.loadingEncuestas = false;
        if (id === this.jobIdPanel) this.loadingPanel = false;
      }
    },

    downloadFile(file) {
      if (!file) return;
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}
</script>

<style scoped>
.v-card-title {
  border: 1px solid #000;
  text-align: center;
}
</style>
